import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SignupPage } from './pages/SignupPage';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';
import ZoomInfo from './components/ZoomInfoHelmet';
import Clarity from './components/ClarityHeatMapHelmet';
import getLocale from './helper/Locale';

import './App.css';

import TagManager from 'react-gtm-module';

function App() {
  const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

  const { i18n } = useTranslation();

  const changeAppLanguage = useCallback(async () => {
    const locale = getLocale();
    if (i18n.language !== locale) {
      try {
        await i18n.changeLanguage(locale);
      } catch (error) {
        console.error("Error changing language:", error);
      }
    }
  }, [i18n]);

  const initializeGTM = useCallback(() => {
    if (GTM_ID) {
      TagManager.initialize({ gtmId: GTM_ID });
    }
  }, [GTM_ID]);

  useEffect(() => {
    changeAppLanguage();
    initializeGTM();
  }, [changeAppLanguage, initializeGTM]);

  return (
    <HelmetProvider>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&family=Open+Sans:wght@400;600&display=swap" rel="stylesheet" />
        <meta name="description" content="Enhance your delivery process with Cigo Tracker's Last Mile Tracking. Our advanced route optimization and real-time updates ensure timely deliveries, reduced costs, and increased customer satisfaction. Experience efficiency and transparency in every delivery." />
        <meta name="keywords" content="Last Mile Delivery, Tracking, Efficient Routing, Delivery Management, Customer Trust" />
      </Helmet>
      <div className="App">
        <ZoomInfo />
        <Clarity />
        <SignupPage />
      </div>
    </HelmetProvider>
  );
}

export default App;
